"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _UserModel = _interopRequireDefault(require("../../users/all-users/models/UserModel"));

var _AppSelect = _interopRequireDefault(require("../../../components/crud/AppSelect"));

var _NotificationUserGroupModel = _interopRequireDefault(require("../models/NotificationUserGroupModel"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var TargetUsers = /*#__PURE__*/function (_React$Component) {
  _inherits(TargetUsers, _React$Component);

  function TargetUsers() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, TargetUsers);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(TargetUsers)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      userId: null
    });

    return _this;
  }

  _createClass(TargetUsers, [{
    key: "_selectOneUser",
    value: function _selectOneUser(formHandler) {
      return _react["default"].createElement(_AppSelect["default"], {
        key: "user",
        textFieldProps: {
          label: 'Select user',
          InputLabelProps: {
            shrink: true
          }
        },
        model: _UserModel["default"],
        name: "userId",
        value: formHandler.state.record.userId,
        handler: formHandler,
        placeholder: "Select user",
        getOptionLabel: function getOptionLabel(user) {
          return user.id ? user.fullName + ' (ID:' + user.id + ')' : '- any -';
        }
      });
    }
  }, {
    key: "_selectUserGroup",
    value: function _selectUserGroup(formHandler) {
      return _react["default"].createElement(_AppSelect["default"], {
        key: "group",
        textFieldProps: {
          label: 'Select user group',
          InputLabelProps: {
            shrink: true
          }
        },
        model: _NotificationUserGroupModel["default"],
        name: "userGroupId",
        value: formHandler.state.record.userGroupId,
        handler: formHandler,
        placeholder: "Select user group",
        getOptionLabel: function getOptionLabel(user) {
          return user.id ? user.name : '- any -';
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          sendTo = _this$props.sendTo,
          formHandler = _this$props.formHandler;
      if (sendTo == 'all') return null;

      if (sendTo == 'one') {
        return this._selectOneUser(formHandler);
      }

      if (sendTo == 'group') {
        return this._selectUserGroup(formHandler);
      }

      return null;
    }
  }]);

  return TargetUsers;
}(_react["default"].Component);

exports["default"] = TargetUsers;